import { FC, PropsWithChildren, ReactElement } from 'react';

import MaintenanceScreen from 'components/MaintenanceScreen';
import useCompatibilityGate from './useCompatibilityGate.hook';

const CompatibilityGate: FC<PropsWithChildren> = ({
  children,
}): ReactElement => {
  const { isBlocked, isMaintenance } = useCompatibilityGate();

  if (isBlocked || isMaintenance) {
    return (
      <MaintenanceScreen isBlocked={isBlocked} isMaintenance={isMaintenance} />
    );
  }

  return <>{children}</>;
};

export default CompatibilityGate;
